import { render, staticRenderFns } from "./bs5-wrapper.vue?vue&type=template&id=171deacf&scoped=true&"
var script = {}
import style0 from "./bs5-wrapper.vue?vue&type=style&index=0&id=171deacf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171deacf",
  null
  
)

export default component.exports